import { errorToast, successToast } from '@components/toasts/Toasts';
import { useMutation } from '@tanstack/react-query';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { MultiTableReservationData } from 'restaurantAdmin/reservations/concierge/types';
import { updateLargePartyReservation } from 'restaurantAdmin/reservations/service/apiHelpers';
import { useReservationServiceContext } from '../state/ReservationServiceContext';
import { useFetchOccupantDetails } from './useFetchOccupantDetails';

export const useUpdateLargePartyReservationMutation = ({
  reservationId,
}: {
  reservationId: string;
}) => {
  const { id: restaurantId } = useRestaurant();
  const { refreshOccupants } = useReservationServiceContext();
  const { invalidate } = useFetchOccupantDetails({
    id: reservationId,
    type: 'reservation',
  });

  return useMutation({
    mutationFn: ({
      floorPlanTableIds,
      guestCount,
      duration,
      date,
      time,
    }: MultiTableReservationData) => {
      return updateLargePartyReservation({
        restaurantId,
        reservationId,
        floorPlanTableIds,
        guestCount,
        duration,
        date,
        time,
      });
    },
    onError: () => {
      errorToast({
        message: 'Failed to update large-party reservation. Please try again.',
      });
    },
    onSuccess: () => {
      successToast({
        message: 'Reservation updated successfully!',
      });
      invalidate();
      refreshOccupants();
    },
  });
};
